import {
  HOME_CLEAR_SCHEDULE_BEGIN,
  HOME_CLEAR_SCHEDULE_SUCCESS,
  HOME_CLEAR_SCHEDULE_FAILURE,
  HOME_CLEAR_SCHEDULE_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function clearSchedule(schedule) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CLEAR_SCHEDULE_BEGIN,
    });

    let hasUnlockedAssignments = schedule.scheduleAssignments.some(sa => !sa.wasUploaded && !sa.locked && sa.location);

    const promise = new Promise((resolve, reject) => {
      axios.put("/api/schedules/",{id: schedule.id,
        seasonId:schedule.seasonId,
        description: schedule.description,
        creation: schedule.creation,
        scheduleAssignments: schedule.scheduleAssignments.map(sa => {
          //never clear uploaded assignments. Clear locked only if there are no unlocked.
          if (sa.wasUploaded || (hasUnlockedAssignments && sa.locked)) 
            return sa; 
          return {...sa, location:""}; //reset assignment
          })
      }).then(
        (res) => {
          dispatch({
            type: HOME_CLEAR_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CLEAR_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissClearScheduleError() {
  return {
    type: HOME_CLEAR_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CLEAR_SCHEDULE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        clearSchedulePending: true,
        clearScheduleError: null,
      };

    case HOME_CLEAR_SCHEDULE_SUCCESS:
      // The request is success
      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          [action.data.id]: action.data
        },
        clearSchedulePending: false,
        clearScheduleError: null,
      };

    case HOME_CLEAR_SCHEDULE_FAILURE:
      // The request is failed
      return {
        ...state,
        clearSchedulePending: false,
        clearScheduleError: action.data.error,
      };

    case HOME_CLEAR_SCHEDULE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        clearScheduleError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/clearSchedule.js